export default "__VITE_ASSET__BBqeYEAt__"